import React from 'react';
import { useNavigate } from 'react-router-dom';
import { artworks } from '../mock';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen pt-16 bg-[#1a1a1a]">
      {/* Hero Section - Smaller */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 border-b border-gray-800">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-3 uppercase">
            Aaron W.
          </h1>
          <p className="text-sm md:text-base text-gray-400 font-light tracking-wide">
            Crafting digital worlds and characters with precision
          </p>
        </div>
      </section>

      {/* Artwork Grid - 3 Columns */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {artworks.map((artwork, index) => (
              <div
                key={artwork.id}
                className="artwork-section group relative cursor-pointer overflow-hidden border border-gray-600 aspect-[4/5]"
                onClick={() => navigate(`/artwork/${artwork.slug}`)}
              >
                {/* Artwork Image */}
                <div className="absolute inset-0">
                  <img
                    src={artwork.thumbnail}
                    alt={artwork.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  {/* Dark overlay on hover */}
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>

                {/* Show title on hover over the artwork section */}
                <div className="absolute inset-0 flex items-end justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-20">
                  <div className="mb-6 bg-black/90 px-6 py-3 border border-white/30">
                    <h3 className="text-white text-lg font-bold uppercase tracking-wider">{artwork.title}</h3>
                    <p className="text-gray-300 text-xs tracking-wide mt-1">{artwork.year} · {artwork.medium}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 border-t border-gray-800">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 tracking-tight uppercase">
            Let's Create Together
          </h2>
          <p className="text-base text-gray-400 mb-8 tracking-wide">
            Available for freelance projects and collaborations
          </p>
          <button
            onClick={() => navigate('/contact')}
            className="inline-block px-10 py-4 bg-white text-black font-bold uppercase tracking-wider hover:bg-gray-200 transition-colors duration-300 border-2 border-white"
          >
            Get In Touch
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
